import { render, staticRenderFns } from "./ManageDropdowns.vue?vue&type=template&id=60047bd2"
import script from "./ManageDropdowns.vue?vue&type=script&lang=ts"
export * from "./ManageDropdowns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports